import React from "react";

import { Grid, GridProps, Typography, Divider } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  outer: {
    gap: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

export const BlockStandard = ({
  children,
  title,
  hideDivider,
}: BlockStandardProps) => {
  const { classes } = useStyles();

  return (
    <Grid container item direction="column" className={classes.outer}>
      {title && <Typography variant="h3">{title}</Typography>}
      {children}
      {!hideDivider && <Divider />}
    </Grid>
  );
};

type BlockProps = {
  children: GridProps["children"];
  title?: string;
  hideDivider?: boolean;
};

export type BlockStandardProps = BlockProps;
